module.exports = __webpack_public_path__ + "static/media/ic_delete_images.bdfdb584.svg";